module.exports = __webpack_public_path__ + "img/Weapon_105.6e2ebf74.png";